export const imaginationCueTypes = {
  RED: 'RED',
  GREEN: 'GREEN',
  MIXED_HORIZENTAL: 'MIXED_HORIZENTAL',
  MIXED_VERTICAL: 'MIXED_VERTICAL',
  MIXED: 'MIXED',
  RG: 'RG',
  GR: 'GR',
}
